document.addEventListener("DOMContentLoaded", function () {
  const widthFeet = localStorage.getItem("WidthFeet");
  const widthInches = localStorage.getItem("WidthInches");
  const lengthFeet = localStorage.getItem("LengthFeet");
  const lengthInches = localStorage.getItem("LengthInches");

  const isAnyValuePresent =
    widthFeet || widthInches || lengthFeet || lengthInches;

  if (isAnyValuePresent) {
    setTimeout(() => {
      const rectangleBtn = document.querySelector("#CustomRugshape-rectangle");
      const squareBtn = document.querySelector("#CustomRugshape-square");
      if (squareBtn) {
        squareBtn.click();
      }
      if (rectangleBtn) {
        rectangleBtn.click();
      } else {
        return;
      }

      const widthFeetInput = document.querySelector(
        'input[name="properties[width-feet]"]'
      );
      const widthInchesInput = document.querySelector(
        'input[name="properties[width-inches]"]'
      );
      const lengthFeetInput = document.querySelector(
        'input[name="properties[length-feet]"]'
      );
      const lengthInchesInput = document.querySelector(
        'input[name="properties[length-inches]"]'
      );

      // Helper function to set the input value and dispatch a 'change' event
      function setInputValueAndDispatchEvent(inputElement, value) {
        if (inputElement && value !== null) {
          inputElement.value = value;
          const event = new Event("change", { bubbles: true });
          inputElement.dispatchEvent(event);
        }
      }

      setInputValueAndDispatchEvent(widthFeetInput, widthFeet);
      setInputValueAndDispatchEvent(widthInchesInput, widthInches);
      setInputValueAndDispatchEvent(lengthFeetInput, lengthFeet);
      setInputValueAndDispatchEvent(lengthInchesInput, lengthInches);

      // Your existing Cylindo element hiding logic
      const element = document.querySelector(
        '[cylindo-variant-selector="Size"]'
      );
      setTimeout(() => {
        if (element) {
          element.querySelector(".cylindoVariant__options").style.overflow =
            "hidden";
          element.querySelector(".cylindoVariant__options").style.height = "0";
        }
      }, 100);
    }, 500);
  }
});

// Accessiblility Js
document.querySelectorAll(".nav__menuItem").forEach((item) => {
  const link = item.querySelector(".nav__link");

  item.addEventListener("mouseenter", () => {
    link.setAttribute("aria-expanded", "true");
  });

  item.addEventListener("mouseleave", () => {
    link.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("shopify-section-footer");
  if (el) el.setAttribute("role", "contentinfo");
});
function updateSlideVisibility() { 
  document.querySelectorAll('.swiper-slide').forEach(slide => {
    const variant = slide.querySelector('.cylindoVariant__option');
    if (variant) { 
      const availability = variant.getAttribute('data-availability');
      if (availability === 'false') {
        slide.style.display = 'none';
      } else {
        slide.style.display = '';
      }
    }
  });
}
setTimeout(updateSlideVisibility, 1000);

const observer_mutation = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'data-availability'
    ) {
      updateSlideVisibility();
      break;
    }
  }
});

function observeVariants() {
  document.querySelectorAll('.cylindoVariant__option').forEach(variant => {
    observer_mutation.observe(variant, { attributes: true });
  });
}
setTimeout(observeVariants, 1000);

// sub-category on collection page
   
document.addEventListener("DOMContentLoaded", function() {
const wrappers = document.querySelectorAll(".sub-category-menu-wrapper");
if (!wrappers.length) return; 

wrappers.forEach((wrapper) => {
const scroller = wrapper.querySelector(".sub-category-menu");
const btnLeft = wrapper.querySelector(".sub-cat-arrow--left");
const btnRight = wrapper.querySelector(".sub-cat-arrow--right");
if (!scroller || !btnLeft || !btnRight) return; 


const getScrollStep = () => Math.floor(scroller.clientWidth * 0.8);

const updateArrows = () => {
const maxScroll = scroller.scrollWidth - scroller.clientWidth;
const atStart = scroller.scrollLeft <= 2;
const atEnd = scroller.scrollLeft >= maxScroll - 2;

btnLeft.setAttribute("aria-hidden", atStart);
btnRight.setAttribute("aria-hidden", atEnd);
btnLeft.disabled = atStart;
btnRight.disabled = atEnd;


if (scroller.scrollWidth <= scroller.clientWidth + 1) {
  btnLeft.setAttribute("aria-hidden", "true");
  btnRight.setAttribute("aria-hidden", "true");
  btnLeft.disabled = true;
  btnRight.disabled = true;
}
};

const scrollByStep = (dir) => {
scroller.scrollBy({ left: getScrollStep() * dir, behavior: "smooth" });

clearTimeout(scroller._scrollTimeout);
scroller._scrollTimeout = setTimeout(updateArrows, 250);
};


btnLeft.addEventListener("click", () => scrollByStep(-1));
btnRight.addEventListener("click", () => scrollByStep(1));


let ticking = false;
scroller.addEventListener("scroll", () => {
if (!ticking) {
  requestAnimationFrame(() => {
    updateArrows();
    ticking = false;
  });
  ticking = true;
}
}, { passive: true });


window.addEventListener("resize", () => {
clearTimeout(scroller._resizeTimeout);
scroller._resizeTimeout = setTimeout(updateArrows, 150);
});


scroller.addEventListener("focusin", (e) => {
const el = e.target;
if (!el || !scroller.contains(el)) return;
const left = el.offsetLeft;
const right = left + el.offsetWidth;
if (left < scroller.scrollLeft) {
  scroller.scrollTo({ left: left - 12, behavior: "smooth" });
} else if (right > scroller.scrollLeft + scroller.clientWidth) {
  scroller.scrollTo({ left: right - scroller.clientWidth + 12, behavior: "smooth" });
}
});

scroller.scrollLeft = 0;
setTimeout(updateArrows, 80);
});
});

// end sub-category

// Handle variant media gallery with custom.media_gallery metafield
(function() {
  'use strict';
  
  // Parse ProductGalleryData from the page
  function getProductGalleryData() {
    try {
      const script = document.getElementById('ProductGalleryData');
      if (script) {
        return JSON.parse(script.textContent);
      }
    } catch (e) {
      console.error('Error parsing ProductGalleryData:', e);
    }
    return null;
  }
  
  // Update gallery to show custom.media_gallery images if available
  function updateGalleryWithMetafield(variantId) {
    const galleryData = getProductGalleryData();
    
    if (!galleryData || !galleryData.variantGalleries) return false;
    
    // Check if variant has custom gallery images in ProductGalleryData
    const variantGallery = galleryData.variantGalleries[variantId];
    
    if (variantGallery && Array.isArray(variantGallery) && variantGallery.length > 0) {
      
      // Get the main gallery slides
      const mainGalleryWrapper = document.querySelector('.product-gallery__main .swiper-wrapper');
      const thumbGalleryWrapper = document.querySelector('.product-gallery__thumbs .swiper-wrapper');
      
      if (mainGalleryWrapper && thumbGalleryWrapper) {
        // Hide all images in main gallery
        const allMainImages = mainGalleryWrapper.querySelectorAll('.swiper-slide');
        allMainImages.forEach(slide => {
          slide.style.display = 'none';
        });
        
        // Hide all thumbnails
        const allThumbImages = thumbGalleryWrapper.querySelectorAll('.swiper-slide');
        allThumbImages.forEach(slide => {
          slide.style.display = 'none';
        });
        
        // Show only the images that match the custom.media_gallery
        const customMediaIds = variantGallery.map(media => media.id);
        
        customMediaIds.forEach((mediaId, index) => {
          // Show main gallery image - use data-thumbnail-id since that's what's in the template
          const mainImage = mainGalleryWrapper.querySelector(`[data-thumbnail-id="${mediaId}"]`);
          if (mainImage) {
            mainImage.style.display = '';
            // Set as active slide if it's the first one
            if (index === 0 && mainImage.classList.contains('swiper-slide')) {
              mainImage.classList.add('swiper-slide-active');
            }
          }
          
          // Show thumbnail
          const thumbImage = thumbGalleryWrapper.querySelector(`[data-thumbnail-id="${mediaId}"]`);
          if (thumbImage) {
            thumbImage.style.display = '';
            // Set as active thumbnail if it's the first one
            if (index === 0 && thumbImage.classList.contains('swiper-slide')) {
              thumbImage.classList.add('swiper-slide-active');
            }
          }
        });
        
        // Update swiper slides to first visible image
        setTimeout(() => {
          const mainSwiper = mainGalleryWrapper.closest('.swiper')?.swiper;
          const thumbsSwiper = thumbGalleryWrapper.closest('.swiper')?.swiper;
          
          if (mainSwiper) {
            mainSwiper.slideTo(0, 0);
          }
          if (thumbsSwiper) {
            thumbsSwiper.slideTo(0, 0);
          }
        }, 50);
        
        return true;
      }
    }
    
    return false;
  }
  
  // Listen for variant change events
  document.addEventListener('flu:product:variant-change', function(evt) {
    if (evt.detail && evt.detail.variant) {
      const variant = evt.detail.variant;
      const variantId = variant.id;
      
      // Try to update gallery with custom media gallery
      const updated = updateGalleryWithMetafield(variantId);
      
      // If no custom media gallery was found, let the default behavior handle it
      if (!updated) {
        console.log('No custom.media_gallery found for variant, using default behavior');
      }
    }
  });
  
  // Also listen for the custom variant change events used by the new system
  document.addEventListener('variant:changed', function() {
    // Try to get the currently selected variant from the form
    const form = document.querySelector('[data-product-form]');
    if (form) {
      const variantSelect = form.querySelector('select[name="id"]');
      if (variantSelect && variantSelect.value) {
        const variantId = parseInt(variantSelect.value);
        updateGalleryWithMetafield(variantId);
      }
    }
  });
  
  console.log('Variant media gallery metafield handler initialized');
})();
// Custom main gallery navigation arrows
(function() {
  'use strict';
  
  let mainSwiper = null;
  let thumbsSwiper = null;
  
  function getSwiperInstances() {
    if (!mainSwiper) {
      const mainSwiperEl = document.querySelector('.product-gallery__main .swiper');
      if (mainSwiperEl && mainSwiperEl.swiper) {
        mainSwiper = mainSwiperEl.swiper;
      }
    }
    
    if (!thumbsSwiper) {
      const thumbsSwiperEl = document.querySelector('.product-gallery__thumbs .swiper');
      if (thumbsSwiperEl && thumbsSwiperEl.swiper) {
        thumbsSwiper = thumbsSwiperEl.swiper;
      }
    }
    
    return { mainSwiper, thumbsSwiper };
  }
  
  function getVisibleSlides() {
    if (!mainSwiper) return [];
    // Get slides that are not hidden with display:none
    const slides = Array.from(mainSwiper.slides);
    return slides.filter(slide => slide.style.display !== 'none');
  }
  
  function updateArrowStates() {
    const { mainSwiper } = getSwiperInstances();
    const prevBtn = document.querySelector('[data-custom-nav="prev"]');
    const nextBtn = document.querySelector('[data-custom-nav="next"]');
    
    if (!prevBtn || !nextBtn) return;
    
    // If no swiper or slides, hide arrows
    if (!mainSwiper || !mainSwiper.slides || mainSwiper.slides.length === 0) {
      prevBtn.disabled = true;
      prevBtn.classList.add('swiper-button-disabled');
      nextBtn.disabled = true;
      nextBtn.classList.add('swiper-button-disabled');
      return;
    }
    
    const visibleSlides = getVisibleSlides();
    const visibleCount = visibleSlides.length;
    
    // If only 1 or no visible slides, disable both arrows
    if (visibleCount <= 1) {
      prevBtn.disabled = true;
      prevBtn.classList.add('swiper-button-disabled');
      nextBtn.disabled = true;
      nextBtn.classList.add('swiper-button-disabled');
      return;
    }
    
    const activeIndex = mainSwiper.activeIndex;
    const activeSlide = mainSwiper.slides[activeIndex];
    
    // Find the current position in visible slides array
    const currentVisibleIndex = visibleSlides.indexOf(activeSlide);
    
    // Enable/disable prev arrow
    if (currentVisibleIndex <= 0) {
      prevBtn.disabled = true;
      prevBtn.classList.add('swiper-button-disabled');
    } else {
      prevBtn.disabled = false;
      prevBtn.classList.remove('swiper-button-disabled');
    }
    
    // Enable/disable next arrow
    if (currentVisibleIndex >= visibleCount - 1) {
      nextBtn.disabled = true;
      nextBtn.classList.add('swiper-button-disabled');
    } else {
      nextBtn.disabled = false;
      nextBtn.classList.remove('swiper-button-disabled');
    }
  }
  
  function navigateGallery(direction) {
    const { mainSwiper, thumbsSwiper } = getSwiperInstances();
    
    if (!mainSwiper) {
      console.log('Main swiper not found');
      return;
    }
    
    const currentIndex = mainSwiper.activeIndex;
    const visibleSlides = Array.from(mainSwiper.slides).filter(slide => slide.style.display !== 'none');
    
    let targetSlide = null;
    
    if (direction === 'next') {
      // Find next visible slide
      for (let i = currentIndex + 1; i < mainSwiper.slides.length; i++) {
        if (mainSwiper.slides[i].style.display !== 'none') {
          targetSlide = mainSwiper.slides[i];
          break;
        }
      }
    } else if (direction === 'prev') {
      // Find previous visible slide
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (mainSwiper.slides[i].style.display !== 'none') {
          targetSlide = mainSwiper.slides[i];
          break;
        }
      }
    }
    
    if (targetSlide) {
      const targetIndex = Array.from(mainSwiper.slides).indexOf(targetSlide);
      mainSwiper.slideTo(targetIndex);
      
      // Also update thumbs swiper if it exists
      if (thumbsSwiper) {
        thumbsSwiper.slideTo(targetIndex);
      }
      
      setTimeout(updateArrowStates, 100);
    }
  }
  
  // Initialize on DOM ready
  function init() {
    const prevBtn = document.querySelector('[data-custom-nav="prev"]');
    const nextBtn = document.querySelector('[data-custom-nav="next"]');
    
    if (!prevBtn || !nextBtn) return;
    
    // Wait for Swiper to initialize
    setTimeout(() => {
      getSwiperInstances();
      
      if (!mainSwiper) {
        console.log('Waiting for swiper initialization...');
        setTimeout(init, 500);
        return;
      }
      
      // Add click listeners
      prevBtn.addEventListener('click', () => navigateGallery('prev'));
      nextBtn.addEventListener('click', () => navigateGallery('next'));
      
      // Update arrow states initially
      updateArrowStates();
      
      // Listen to swiper slide change events
      if (mainSwiper) {
        mainSwiper.on('slideChange', () => {
          setTimeout(updateArrowStates, 50);
        });
      }
      
      // Watch for slide visibility changes (when slides are hidden/shown)
      const mainSwiperEl = document.querySelector('.product-gallery__main .swiper');
      if (mainSwiperEl) {
        const observer = new MutationObserver(() => {
          setTimeout(updateArrowStates, 100);
        });
        
        // Watch for style changes on slides
        const config = { 
          attributes: true, 
          attributeFilter: ['style'],
          subtree: true,
          childList: true
        };
        
        observer.observe(mainSwiperEl, config);
      }
      
      // Update on variant change - with proper re-initialization
      const handleVariantChange = () => {
        // Clear cached instances
        mainSwiper = null;
        thumbsSwiper = null;
        
        // Wait for slides to be updated (hidden/shown)
        setTimeout(() => {
          // Re-get swiper instances
          const { mainSwiper: newMainSwiper } = getSwiperInstances();
          
          if (newMainSwiper) {
            // Re-attach slideChange listener to new instance
            newMainSwiper.on('slideChange', () => {
              setTimeout(updateArrowStates, 50);
            });
            
            // Update swiper to recalculate
            newMainSwiper.update();
            
            // Update arrow states
            updateArrowStates();
            
            console.log('Arrows updated after variant change');
          }
        }, 200);
      };
      
      document.addEventListener('flu:product:variant-change', handleVariantChange);
      document.addEventListener('variant:changed', handleVariantChange);
      
      console.log('Custom main gallery navigation initialized');
    }, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();